import type React from 'react';
import { Login } from './Login';

export const ExternalLogin: React.VFC = () => (
  <Login action="/login/external" type="external" />
);
